import type { RouteRecordRaw } from 'vue-router';
import { buildRootURL } from '@centric-os/helpers';
import { LoyaltyRouteNames, LoyaltyRoutePathNames } from '../enums';
import childRoutes from './children';

const App = () => import('./../App.vue');

const rootRoute: RouteRecordRaw = {
  path: buildRootURL(LoyaltyRoutePathNames.LOYALTY),
  name: LoyaltyRouteNames.LOYALTY_ROOT,
  meta: {
    requireAuth: true,
  },
  component: App,
  children: childRoutes,
};

export default rootRoute;
